import { render, staticRenderFns } from "./MarketPricesCalculation.vue?vue&type=template&id=390943e7&scoped=true"
import script from "./MarketPricesCalculation.vue?vue&type=script&lang=js"
export * from "./MarketPricesCalculation.vue?vue&type=script&lang=js"
import style0 from "./MarketPricesCalculation.vue?vue&type=style&index=0&id=390943e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390943e7",
  null
  
)

export default component.exports